module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "change-accounts"
    }
  }, [_c('span', [_vm._v("Selecionar conta:")]), _c('companies-autocomplete', {
    attrs: {
      "external_id": "change"
    },
    on: {
      "selected-company": _vm.selectedCompany
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2fb60744!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/header_actions/change_account.vue
// module id = 1063
// module chunks = 1